import { addDays } from 'date-fns'

export const useSubscriptionContent = () => {
  const calculateEndDate = (start: Date, validity: number | string) => {
    return addDays(new Date(start), typeof validity !== 'string' ? validity : 0)
  }

  return { calculateEndDate }
}
